import ForecastFeedbackPrompt from './ForecastFeedbackPrompt';

export default ForecastFeedbackPrompt;
